import { render, staticRenderFns } from "./CertificationModal.vue?vue&type=template&id=37b3ee7a"
import script from "./CertificationModal.vue?vue&type=script&lang=ts"
export * from "./CertificationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b3ee7a')) {
      api.createRecord('37b3ee7a', component.options)
    } else {
      api.reload('37b3ee7a', component.options)
    }
    module.hot.accept("./CertificationModal.vue?vue&type=template&id=37b3ee7a", function () {
      api.rerender('37b3ee7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/certifications/CertificationModal.vue"
export default component.exports